// import 'home.css'
 function Home1() {
  return (
    <div>Home1</div>
  )
}


export default Home1